export default __webpack_public_path__ + "static/media/icon-academic-cap.a3631ebc.svg";